import { can, type Permission } from '@repo/shared-types';
import { useAuthStore } from '../stores/authStore';

/** Thin-multi RBAC: true if the current member's role has the given permission.
 * MEMBER (assistant teacher) can only view + mark attendance; OWNER/ADMIN can
 * do everything structural/financial. See packages/shared-types/src/permissions.ts. */
export function useCan(p: Permission): boolean {
  const role = useAuthStore((s) => s.role);
  return role ? can(role, p) : false;
}
